import { CRM_CONTACT_FIELD_LABELS } from '@/Containers/CrmSection/Components/Contacts'

import type { CrmContactColumn } from '@/Containers/CrmSection/Components/Contacts'

/**
 * Підписи полів контакту перевізника — спільні підписи контакту CRM
 * (`SPEC-008` §4.2), крім пошти: у перевізника вона «E-mail», як у легасі
 * (`CarrierContactResource.js:21-23`, `SPEC-010` §5.4).
 */
export const CARRIER_CONTACT_FIELD_LABELS = {
    ...CRM_CONTACT_FIELD_LABELS,
    email: 'E-mail',
} as const

/** Колонки вкладки «Контакти» — як у легасі (`CarrierContactCrud.jsx:29`). */
export const CARRIER_CONTACT_COLUMNS: CrmContactColumn[] = [
    { key: 'name', title: CARRIER_CONTACT_FIELD_LABELS.name },
    { key: 'lastName', title: CARRIER_CONTACT_FIELD_LABELS.lastName },
    { key: 'email', title: CARRIER_CONTACT_FIELD_LABELS.email },
]
